import React, { ReactNode } from 'react';
import { dateConverter } from '_utils/helpers';

const renderStartDate = (date: string): ReactNode => {
  const { attrDate, visualDate } = dateConverter(date, { serverDate: true });

  return <time dateTime={attrDate}>{visualDate}</time>;
};
const renderEndDate = (date: string): ReactNode => {
  const { attrDate, visualDate } = dateConverter(date, { serverDate: true });

  return <time dateTime={attrDate}>{visualDate}</time>;
};
export { renderStartDate, renderEndDate };
